import ApiService from '../../components/api_services/apiService.jsx';

import { ReactComponent as Edit } from '../../components/icons/edit.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';

import { toggleNeedRefresh, toggleCheckedItem, toggleEditModal, setPage, to, setSortListEndpoint } from '../../store/faqTabSlice.js';

import ClasicArrowDown from '../../components/icons/clasic-arrow-down.jsx';
import ClasicArrowUp from '../../components/icons/clasic-arrow-up.jsx';
import store from '../../store/store.js';


export const fetchFaq = async (dispatch, setRows, checkedItems) => {
  try {
    const response = await ApiService.getFaq();
    console.log('Odpowiedź z API:', response);

    // Mapowanie danych z API do formatu zgodnego z tabelą
    const mappedRows = response.map((data, index) => [
      <input
        type="checkbox"
        checked={checkedItems.includes(data.id)} // Sprawdzenie, czy id znajduje się w checkedItems
        onChange={() => dispatch(toggleCheckedItem(data.id))} // Dodanie/Usunięcie id z listy
      />,
      data.id, // ID
      data.questionPl,
      data.answerPl,
      data.questionEng,
      data.answerEng,
      <div>
        {/*<Edit*/}
        {/*  className="menu-icon"*/}
        {/*  onClick={() => dispatch(toggleEditModal({*/}
        {/*    id: data[0],*/}
        {/*    notification_type: data[5],*/}
        {/*    content_pl: data[1],*/}
        {/*    content_eng: data[2],*/}
        {/*    gender_of_the_sender: data[7],*/}
        {/*    gender_of_the_recipient: data[6],*/}
        {/*    push_enabled: data[3],*/}
        {/*    enabled: data[4]*/}
        {/*  }))}*/}
        {/*  />*/}
        <Trash className="menu-icon" onClick={
          async () => {  // dodajemy async
            try {
              await ApiService.deleteFaq(data.id); // dodajemy await
              dispatch(toggleNeedRefresh());
            } catch (error) {
              console.error('Błąd podczas usuwania:', error);
            }
          }}
        />
      </div>
    ]);

    setRows(mappedRows); // Ustawienie wierszy w stanie
  } catch (error) {
    console.error('Błąd podczas pobierania danych:', error);
  }
};